import { useRef, useState } from "react";
import styles from "./emailTrigger.module.css";
import { connect } from "react-redux";
import { addDemandAction } from "../../../../redux/actions/demand/demand.action";
import { DEMAND_ACTIONS, EMAIL_DELIVERY_STATUS } from "../../../../utils/constants/DemandConstant";
import { ConfirmDialog } from "../../../../hooks/confirmDialog/confirmDialog";
import IMAGES from "../../../../assets/images/images";
import { openAlertPopup } from "../../../../redux/actions/Alert/alert.action";
import { Submit } from "../../../../components/button/buttons";

const EmailTrigger = (props) => {
  const { addDemandAction, requestId, openAlertPopup, handelServiceDetailapi, emailDeliveryStatus=null,orderFormDocUniqueId } = props;
  const [isSubmit, setIsSubmit] = useState(false);
  const [statusEmailSent, setStatusEmailSent] = useState("");
  const [seconds, setSeconds] = useState(30);
  const timeoutRef = useRef(null);
  const intervalRef = useRef(null);

   const countdownPromise= async({
    intervalRef,
    setSeconds,
    start = 30,
    onComplete, // optional async function
  })=>{
    return new Promise((resolve) => {
      // start from `start` seconds
      let remaining = start;
 
      // initialize UI immediately
      setSeconds(remaining);
 
      // clear any previous interval
      if (intervalRef.current) clearInterval(intervalRef.current);
 
      intervalRef.current = setInterval(async () => {
        remaining -= 1;
        setSeconds(remaining);
 
        if (remaining <= 0) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
 
          // run completion work (can be async)
          try {
            if (onComplete) {
              await onComplete();
            }
          } finally {
            resolve();
          }
        }
      }, 1000);
    });
  }

  const handleClick = async () => {
     const ok = await ConfirmDialog(DEMAND_ACTIONS.INITIATE_LEGAL_CONTRACT);
    if (!ok.confirmed) return false
    setIsSubmit(true)
    setStatusEmailSent("counting")
    // Reset old timers
    if (intervalRef.current) clearInterval(intervalRef.current);
    setSeconds(30);
    let emailSendAction=DEMAND_ACTIONS.INITIATE_LEGAL_CONTRACT
    if(emailDeliveryStatus==EMAIL_DELIVERY_STATUS.FAILED){
      emailSendAction=DEMAND_ACTIONS.RESEND_LEGAL_CONTRACT
    }
    try {const payload = {action:emailSendAction,stateData: {orderFormDocUniqueId:orderFormDocUniqueId}}
    const res = await addDemandAction(payload, requestId);
    if (!res) {
      openAlertPopup({
        message: "Failed to initiate legal contract. Please try again.",
        image: IMAGES.error
      });
      return;
    }
      //STEP 2: start countdown
      await countdownPromise({
        intervalRef,
        setSeconds,             // your setter from useState
        start: 30,              // or any number
        onComplete: async () => {
          setIsSubmit(false);
          setStatusEmailSent("");       // you can set any status/message here
          await handelServiceDetailapi();
        },
      });
      // setIsSubmit(false)
      // await handelServiceDetailapi();
      props.openAlertPopup({
        message: "The legal contract email has been successfully triggered.",
        image: IMAGES.success
      });
    } catch (error){
      props?.openAlertPopup({
        message:"An error occurred while processing your request. Please try again later.",
        image: IMAGES.error,
      });
    } finally {
      setIsSubmit(false);
      setStatusEmailSent("")
      clearInterval(intervalRef.current);
    }
  };

  return (
    <div className={styles.actionContainer}>
      <div className={styles.moduledescription}>
        {
          emailDeliveryStatus==EMAIL_DELIVERY_STATUS.FAILED?
          "The email notification to the VGEL team could not be sent. Please retry by clicking 'Send to VGEL Team' again to share the document and notify the team."
          :"Use the section below to send the customer-signed order form to the 'VGEL team'. Clicking 'Send to VGEL Team' will share the document and notify the team via email."
        }
        </div>

      <div className={styles.actions}>
        <Submit
          onClick={handleClick}
          isSubmitting={isSubmit}
          title="Send to VGEL Team"
          style={styles.headlesend}
        />

        {statusEmailSent === "counting" && (
          <div className={styles.note}>
            Sending email, Please wait… <strong>{seconds}</strong>s
          </div>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return null
};

const mapDispatchToProps = (dispatch) => {
  return {
    addDemandAction: (payload,id)=>{
      return dispatch(addDemandAction(payload,id))
    },
    openAlertPopup: (alertHeader,alertmessage) => {
      return dispatch(openAlertPopup(alertHeader,alertmessage))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailTrigger);